import { asyncAction } from '@jarvis.oddle/core/tools/redux/action'
import { loadPreviewThemeApi, loadThemeApi } from 'api/customisation/client'
import * as C from './constants'

export const loadThemeAction = asyncAction({
  api: loadThemeApi,
  requestAction: C.LOAD_THEME_REQUEST,
  successAction: C.LOAD_THEME_SUCCESS,
  failureAction: C.LOAD_THEME_FAILURE
})

export const loadPreviewThemeAction = asyncAction({
  api: loadPreviewThemeApi,
  requestAction: C.LOAD_PREVIEW_THEME_REQUEST,
  successAction: C.LOAD_PREVIEW_THEME_SUCCESS,
  failureAction: C.LOAD_PREVIEW_THEME_FAILURE
})

export const updateCustomisationSettingAction = ({
  themeSettingData,
  sectionSettingData,
  sortingSectionOrder,
  sortingSectionId,
  currentAction
}) => ({
  type: C.UPDATE_CUSTOMISATION_SETTING,
  payload: {
    themeSettingData,
    sectionSettingData,
    sortingSectionOrder,
    sortingSectionId,
    currentAction
  }
})

export const setPreviewModeAction = ({ previewMode }) => ({
  type: C.SET_PREVIEW_MODE,
  payload: { previewMode }
})
